angular
    .module('eficienciaFiscalModule')
    .component('detalhesTributacaoIcms', {
        bindings: {
            icms: '=',
            empresa: '='
        },
        template: `
        <div>
            <h4 class="margin-10 text-bold">Detalhes ICMS</h4>
            <table class="table table-condensed margin-bottom-0">
                <thead>
                    <tr>
                        <th class="text-featured">
                            Enquadramento do ICMS para revenda no estado de {{$ctrl.empresa.icms.simplesNacional}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="font-md">
                            <span>{{$ctrl.icms.enquadramento}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th>Descrição</th>
                        <th ng-if="$ctrl.icms.fecoep">FECOEP</th>
                        <th>Alíquota</th>
                        <th ng-if="!$ctrl.empresa.icms.simplesNacional">CST</th>
                        <th ng-if="$ctrl.empresa.icms.simplesNacional">CSOSN</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{$ctrl.icms.descricao || ''}}</td>
                        <td ng-if="$ctrl.icms.fecoep">{{$ctrl.icms.fecoep}}%</td>
                        <td>{{$ctrl.icms.aliquota}}%</td>
                        <td ng-if="$ctrl.icms.cst == '101'" class="no-break">PJ: 101/PF: 102</td>
                        <td ng-if="$ctrl.icms.cst != '101'">{{$ctrl.icms.cst}}</td>
                    </tr>
                </tbody>
            </table>
            <div ng-switch="$ctrl.icms.tipo">
                <table ng-switch-when="substituicao_tributaria" class="table table-condensed">
                    <thead>
                        <th>Alíquota ICMS ITEM</th>
                        <th ng-if="$ctrl.icms.utiliza_rbc">% RBC ICMS</th>
                        <th ng-if="$ctrl.icms.utiliza_rbc">Tipo RBC ICMS</th>
                        <th>% MVA</th>
                        <th>Tipo de MVA</th>
                    </thead>
                    <tbody>
                        <td>{{$ctrl.icms.aliquota_apuracao}}%</td>
                        <td ng-if="$ctrl.icms.utiliza_rbc">{{$ctrl.icms.retorno_rbc.aliquota_interna_pessoa_juridica}}%</td>
                        <td ng-if="$ctrl.icms.utiliza_rbc" ng-switch="$ctrl.icms.retorno_rbc.tipo_calculo" class="text-center">
                            <span ng-switch-when="de">De</span>
                            <span ng-switch-when="para">Para</span>
                        </td>
                        <td>
                            {{$ctrl.icms.mva_original ? $ctrl.icms.mva_original : $ctrl.icms.aliquota_interestadual_atacado}}%
                        </td>
                        <td>
                            {{$ctrl.icms.mva_original ? "Ajustada" : "Original"}}
                        </td>
                    </tbody>
                </table>
                <table ng-switch-when="reducao_base_calculo" class="table table-condensed">
                    <thead>
                        <th>Código SPED ICMS</th>
                        <th>Percentual de redução em operações internas com PJ</th>
                        <th>Percentual de redução em operações internas com PF</th>
                    </thead>
                    <tbody>
                        <td>{{$ctrl.icms.codigo_sped_icms}}</td>
                        <td>{{$ctrl.icms.aliquota_interna_pessoa_juridica}}%</td>
                        <td>{{$ctrl.icms.aliquota_interna_pessoa_fisica}}%</td>
                    </tbody>
                </table>
                <table ng-switch-when="isencao" class="table table-condensed">
                    <thead>
                        <th>Código SPED ICMS</th>
                        <th>Alíquota ICMS ITEM</th>
                    </thead>
                    <tbody>
                        <td>{{$ctrl.icms.codigo_sped_icms}}</td>
                        <td>{{$ctrl.icms.aliquota_apuracao}}%</td>
                    </tbody>
                </table>
            </div>
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th>Fonte legal</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-if="$ctrl.icms.fonte_legal_link">
                        <td>
                            <a target="_blank" ng-href="{{$ctrl.icms.fonte_legal_link}}">
                                {{$ctrl.icms.fonte_legal}}
                            </a>
                        </td>
                    </tr>
                    <tr ng-if="!$ctrl.icms.fonte_legal_link">
                        <td>{{$ctrl.icms.fonte_legal}}</td>
                    </tr>
                </tbody>
            </table>
            <div style="overflow: auto" ng-if="$ctrl.icms.observacoes.length && !$ctrl.cest">
                <table class="table table-condensed">
                    <thead>
                        <tr>
                            <th>Observações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <ul style="padding-left: 20px">
                                    <li ng-repeat="observacao in $ctrl.icms.observacoes track by $index" style="text-align: justify;">
                                        {{observacao}}
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        `
    })
